import styled from "styled-components";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import { QRCodeCanvas } from "qrcode.react";
import { FlexColumn, FlexRow, HorizontalDivider } from "./common.styles";
import { multilineEllipsis } from "./base.styles";
export const SharingLinkDetailsSection = styled(FlexColumn) `
    gap: 12px;
    align-self: stretch;
`;
export const SharingLinkDetailsSectionLabel = styled.label `
    font-family: inherit;
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.SEMI_BOLD};
    line-height: 100%;
    letter-spacing: 0.15px;
    color: ${colors.black_main};
`;
export const SharingLinkDetailsQRCodeContainer = styled(FlexColumn) `
    gap: 12px;
    align-items: center;
    align-self: stretch;
`;
export const SharingLinkDetailsQRCodeWrapper = styled.div `
    width: 256px;
    height: 256px;
    border-radius: 12px;
    border: 1px solid ${colors.blue_10};
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;
export const SharingLinkDetailsQRCodeCanvas = styled(QRCodeCanvas) `
    border-radius: 12px;
`;
export const SharingLinkDetailsDetailsCard = styled(FlexColumn) `
    padding: 12px;
    border-radius: 12px;
    background: ${colors.blue_10};
    gap: 12px;
    align-self: stretch;
`;
export const SharingLinkDetailsDetailRow = styled(FlexColumn) `
    gap: 4px;
    align-self: stretch;
`;
export const SharingLinkDetailsDetailLabel = styled.span `
    font-family: inherit;
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.SEMI_BOLD};
    line-height: normal;
    color: ${colors.black_main};
    text-align: left;
`;
export const SharingLinkDetailsDetailValue = styled.span `
    font-family: inherit;
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    color: ${colors.black_light};
    text-align: left;
`;
export const SharingLinkDetailsAccessLogCard = styled(FlexColumn) `
    padding: 12px 0;
    border-radius: 12px;
    background: ${colors.white_main};
    border: 1px solid ${colors.blue_10};
    gap: 0px;
    align-self: stretch;
`;
export const SharingLinkDetailsAccessLogList = styled(FlexColumn) `
    gap: 12px;
    align-self: stretch;
`;
export const SharingLinkDetailsAccessLogRow = styled(FlexRow) `
    align-items: center;
    align-self: stretch;
    padding: 0px 12px;
    gap: 16px;
`;
export const SharingLinkDetailsAccessLogAvatar = styled.div `
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    border-radius: 6px;
    border: 1px solid ${colors.blue_10};
    background: linear-gradient(to bottom, rgba(29, 98, 174, 0.28), rgba(29, 98, 174, 0.4));
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`;
export const SharingLinkDetailsAccessLogAvatarLetter = styled.span `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.white_main};
    text-align: center;
    letter-spacing: 0.15px;
    line-height: normal;
`;
export const SharingLinkDetailsAccessLogTextGroup = styled(FlexColumn) `
    flex: 1;
    min-width: 0;
    gap: 2px;
`;
export const SharingLinkDetailsAccessLogRecipient = styled.span `
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.SEMI_BOLD};
    line-height: normal;
    color: ${colors.black_main};
    text-align: left;
    ${multilineEllipsis(2)}
`;
export const SharingLinkDetailsAccessLogDate = styled.span `
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    color: ${colors.black_light};
    ${multilineEllipsis(2)}
    text-align: left;
`;
export const SharingLinkDetailsHistoryDivider = styled(HorizontalDivider) `
    border-color: ${colors.blue_10};
`;
